// «Mover tramos» (plan 2026-10-15 § 3): el modal ancho de los de tabla, la
// caja lila de cabecera, la tabla de Tramos, la de selección de siempre y los
// avisos de «Corregir». Aquí solo se colocan piezas que ya existen: ninguna
// tarjeta ni lista propia (feedback del usuario, tres veces).
export {
  Body,
  BoxTitle,
  ButtonContainer,
  CloseButton,
  Container,
  ContainerLoader,
  EmptyMessage,
  Field,
  InlineError,
  LilacBox,
  MainButtonStyled,
  Notice,
  NoticeIcon,
  Section,
} from '../RegisterStopModal/styles';
export { Text } from '../EditSegmentModal/styles';
export {
  BelowTable,
  PaginationButtonsStyled,
} from '../TransferSegmentModal/styles';
import styled from 'styled-components';
import { TableScroll as SegmentTableScroll } from '../../../../pages/main/surveillanceRoute/components/SegmentList/styles';
// Las opciones con radio o casilla y su texto: las del selector de calidad.
export {
  SelectorContainer as ChoiceGroup,
  OptionsRow as ChoiceRow,
  OptionRow as ChoiceOption,
  OptionLabel as ChoiceLabel,
} from '../../../inputs/CloudinaryQualitySelector/styles';

/**
 * La tabla de tramos con su propio scroll (23-oct, el usuario): con un
 * recorrido largo el modal no cabía en la pantalla al abrirse. Al elegir el
 * rango el modal crece hacia abajo, y eso sí es lo esperado.
 */
export const RangeTable = styled.div`
  ${SegmentTableScroll} {
    max-height: max(24rem, calc(100vh - 44rem));
  }
`;
